import { render, staticRenderFns } from "./UserProfileUpdate.vue?vue&type=template&id=262baaa2&"
import script from "./UserProfileUpdate.vue?vue&type=script&lang=js&"
export * from "./UserProfileUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports